import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./baseQuery";
import { createTemplateBody, updateTemplateBody } from "../app/groups/bulkGoals/goalItems";

/**
 * Yöneticinin hedef şablonları (mobil goalTemplate.service). Mobil uçlar
 * yalnız JWT ister; sunucu listeyi en çok kullanılan üstte sıralı döndürür,
 * istemci yeniden sıralamaz.
 */
export const goalTemplateApi = createApi({
  reducerPath: "panelGoalTemplates",
  baseQuery: axiosBaseQuery(),
  refetchOnFocus: true,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: 30,
  tagTypes: ["GoalTemplates"],
  endpoints: (builder) => ({
    listGoalTemplates: builder.query({
      query: () => ({ url: "/api/goal-templates/list", method: "POST", data: {} }),
      providesTags: ["GoalTemplates"],
    }),
    createGoalTemplate: builder.mutation({
      query: ({ name, goals }) => ({
        url: "/api/goal-templates/create",
        method: "POST",
        data: createTemplateBody(name, goals),
      }),
      invalidatesTags: ["GoalTemplates"],
    }),
    // Gelmeyen alan değişmez: yalnız ad ya da yalnız hedefler güncellenebilir.
    updateGoalTemplate: builder.mutation({
      query: ({ templateId, name, goals }) => ({
        url: "/api/goal-templates/update",
        method: "PUT",
        data: updateTemplateBody(templateId, { name, goals }),
      }),
      invalidatesTags: ["GoalTemplates"],
    }),
    deleteGoalTemplate: builder.mutation({
      query: ({ templateId }) => ({
        url: "/api/goal-templates/delete",
        method: "DELETE",
        data: { templateId },
      }),
      invalidatesTags: ["GoalTemplates"],
    }),
  }),
});

export const {
  useListGoalTemplatesQuery,
  useCreateGoalTemplateMutation,
  useUpdateGoalTemplateMutation,
  useDeleteGoalTemplateMutation,
} = goalTemplateApi;
